/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_Customer_LabelInputs */

const tr_mesafeli_s8_customer_label = /** @type {(inputs: Mesafeli_S8_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri'nin yükümlülükleri:`)
};

const en_mesafeli_s8_customer_label = /** @type {(inputs: Mesafeli_S8_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer's obligations:`)
};

const de_mesafeli_s8_customer_label = /** @type {(inputs: Mesafeli_S8_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflichten des Kunden:`)
};

const ru_mesafeli_s8_customer_label = /** @type {(inputs: Mesafeli_S8_Customer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обязанности Клиента:`)
};

/**
* | output |
* | --- |
* | "Customer's obligations:" |
*
* @param {Mesafeli_S8_Customer_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_customer_label = /** @type {((inputs?: Mesafeli_S8_Customer_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_Customer_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_customer_label(inputs)
	if (locale === "de") return de_mesafeli_s8_customer_label(inputs)
	if (locale === "ru") return ru_mesafeli_s8_customer_label(inputs)
	return tr_mesafeli_s8_customer_label(inputs)
});